'use strict';

const Moment = require('moment');
const NotifyAPI = require('notify/infra/api/notify');
const ReviewStore = require('notify/domain/repository/review');
const CountBadgeTemplate = require('common/ui/template/count-badge.hbs');
const ReviewTemplate = require('notify/ui/template/header/review.hbs');
const NewReviewTemplate = require('notify/ui/template/header/new-review.hbs');
const Backbone = require('backbone');

const ReviewCount = Backbone.Marionette.View.extend({
    tagName: 'span',
    template: CountBadgeTemplate,
    serializeData: function () {
        const count = this.getOption('count');
        return {
            count: count < 100 ? count : '99+'
        };
    }
});

const NewReview = Backbone.Marionette.View.extend({
    className: 'new-review',
    tagName: 'span',
    template: NewReviewTemplate
});

module.exports = Backbone.Marionette.View.extend({
    tagName: 'div',
    template: ReviewTemplate,
    events: {
        'click': 'toggleReviewList'
    },
    regions: {
        reviewCount: '.review-count',
        newReview: '.has-new-review'
    },

    initialize: function() {
        const reviews = ReviewStore.getReviews();
        this._show = false;
        this._latestReadTime = Moment();

        this.listenTo(reviews, 'add', this.toggleNewReview);
        this.listenTo(reviews, 'add remove change:read reset', this.renderReviewCount);
    },

    toggleReviewList: function() {
        this._latestReadTime = Moment();
        this.getRegion('newReview').empty();

        this.triggerMethod('toggle:review');
    },

    toggleNewReview: function() {
        if(ReviewStore.getReviews().filter(r => {
                return Moment(r.getCreatedAt()) > this._latestReadTime;
            })
                .length > 0) {
            this.showChildView('newReview', new NewReview());
        } else {
            this.getRegion('newReview').empty();
        }
    },

    renderReviewCount: function() {
        NotifyAPI.getReviewCount()
            .then(data => {
                this.showChildView('reviewCount', new ReviewCount({
                    count: data.count
                }));
            });
    },

    activate: function() {
        this.$('.menu-icon').addClass('is-active');
    },

    deactivate: function() {
        this.$('.menu-icon').removeClass('is-active');
    }
});



// WEBPACK FOOTER //
// ./notify/ui/view/header/review.js